// frontend/src/components/ProtectedRoute.jsx

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function ProtectedRoute({ children, permission }) {
  const { user, loading, hasPermission } = useAuth();

  if (loading) {
    return (
      <div className="container-fluid py-4">
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
            <span className="visually-hidden">Cargando...</span>
          </div>
          <p className="text-muted mt-3">Verificando permisos...</p>
        </div>
      </div>
    );
  }

  if (!user || !user.is_approved) {
    return <Navigate to="/pending-approval" replace />;
  }

  if (permission && !hasPermission(permission)) {
    return (
      <div className="container-fluid py-4">
        <div className="row justify-content-center">
          <div className="col-lg-6">
            <div className="card shadow border-0">
              <div className="card-body text-center py-5">
                <div className="icon icon-shape bg-gradient-danger shadow text-center rounded-circle mb-4 mx-auto" style={{ width: '80px', height: '80px' }}>
                  <i className="ni ni-fat-remove text-white" style={{ fontSize: '2rem', lineHeight: '80px' }}></i>
                </div>
                <h3 className="text-danger mb-3">Acceso Denegado</h3>
                <p className="text-muted mb-4">
                  No tienes permisos para acceder a esta página.
                </p>
                <button 
                  className="btn btn-primary"
                  onClick={() => window.history.back()}
                >
                  <i className="ni ni-bold-left me-2"></i>
                  Volver
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return children;
}

export default ProtectedRoute;
